module.exports = __webpack_public_path__ + "static/img/AI穿透式监管方案_场景二.8e5f42ef.png";